import { createSlice } from '@reduxjs/toolkit';
const InitialState = {
    strangers: [],
    curStranger: null,
};
const strangerSlice = createSlice({
    name: 'strangerReducer',
    initialState: InitialState,
    reducers: {
        setStrangers: (state, action) => {
            state.strangers = action.payload;
        },
        setCurStranger: (state, action) => {
            state.curStranger = action.payload;
        },
        removeStrangers: (state, action) => {
            const removedAccountNames = action.payload;
            state.strangers = state.strangers.filter(item => {
                const { accountName } = item;
                return !!removedAccountNames.includes(accountName) ? false : true;
            });
        },
    },
});
export const { actions } = strangerSlice;
export default strangerSlice.reducer;
